import { NgModule, Provider } from '@angular/core';
import { NotificationComponent } from './notification.component';
import { DEFAULT_NOTIFICATION_CONFIG, NOTIFICATION_CONFIG } from './provider/notification.provider';
import { NotificationService } from './services/notification.service';

@NgModule({
  imports: [NotificationComponent],
  providers: [provideNotificationDefaultConfig()],
})
export class NotificationModule {}

/**
 * Provides notification default config
 */
export function provideNotificationDefaultConfig(): Provider[] {
  return [
    {
      provide: NOTIFICATION_CONFIG,
      useValue: DEFAULT_NOTIFICATION_CONFIG,
    },
    NotificationService,
  ];
}
